export default "__VITE_PUBLIC_ASSET__beaaffc8__"